export const gitVersion = 'main-1.0.13-522-gfdbc3e58';
